var _path, _path2, _path3, _path4, _path5, _path6, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 312.888h512v113.775H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M300.522 204.059H270.84l4.948-37.102 19.787-14.841 19.787 14.841v29.681zm-89.044 0h29.682l-4.948-37.102-19.787-14.841-19.787 14.841v29.681z",
  fill: "#338af3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M275.788 204.059h-39.576v-37.102L256 152.116l19.788 14.841z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M196.638 196.638v81.623c0 19.436 9.389 36.719 23.868 47.555l10.388-2.6 13.109 13.188a59.433 59.433 0 0011.996 1.219c4.087 0 8.077-.415 11.934-1.205l14.964-12.459 8.595 1.834c14.474-10.834 23.868-28.101 23.868-47.531v-81.623l-118.722-.001z",
  fill: "#f0f0f0"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M196.641 196.641h23.745v23.745h-23.745zm47.483 0h23.745v23.745h-23.745zm47.493 0h23.745v23.745h-23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.383 220.383h23.745v23.745h-23.745zm47.493 0h23.745v23.745h-23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.641 244.124h23.745v23.745h-23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.383 267.865h23.745v23.745h-23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.124 244.124h23.745v23.745h-23.745zm47.493 0h23.745v23.745h-23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.876 267.865h23.745v23.745h-23.745zm-23.752 23.752h23.745v23.745h-23.745zm-23.741-.004h-22.212a59.168 59.168 0 0011.536 23.745h10.676v-23.745zm71.234 23.744h10.677a59.188 59.188 0 0011.536-23.745h-22.213v23.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.383 315.357v10.361a59.113 59.113 0 0023.745 10.71v-21.071h-23.745zm47.49 0v21.071a59.1 59.1 0 0023.745-10.71v-10.361h-23.745z"
}))));

export default SvgHr;